import {useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {useGlobalModalContext} from '../../../setup/context/GlobalModal'

export const MsgBox = () => {
  const {hideModal, store} = useGlobalModalContext()
  const {modalProps} = store || {}

  const handleCancel = () => {
    store.onClickCallBack?.('cancel')
    hideModal()
  }
  const handlerOK = () => {
    store.onClickCallBack?.('ok')
    hideModal()
  }

  return (
    <Modal show={store.isShow} onHide={handleCancel} centered={true} aria-hidden='true' tabIndex='-1'>
      <Modal.Header closeButton>
        <Modal.Title>{modalProps?.title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{modalProps?.message}</p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={handleCancel}>
          Close
        </Button>
        <Button variant='primary' onClick={handlerOK}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
